const maskCurrency = 'mask-currency';
const maskCurrencyNoSymbol = 'mask-currency-no-symbol';
const maskPhone = 'mask-phone';
const policyContract = 'Policy/Contract';
const medicalCondition = 'Medical Condition';

// NOTE: QuestionType 'Phone', 'SSN', 'Decimal' and 'Integer' and Units '$' and 'Years' have masks set in getMask.question.service
export const optionsMap = {
    StateOfIssue: {
        validators: ['validateState']
    },
    prefix: {
        options: [
            { key: 'Dr.', value: 'Dr.' },
            { key: 'Mr.', value: 'Mr.' },
            { key: 'Mrs.', value: 'Mrs.' },
            { key: 'Ms.', value: 'Ms.' },
            { key: 'Miss.', value: 'Miss.' },
        ],
        forceType: 'dropdown'
    },
    Name: {
        validators: ['name']
    },
    suffix: {
        options: [
            { key: 'Jr.', value: 'Jr.' },
            { key: 'Sr.', value: 'Sr.' },
            { key: 'I', value: 'I' },
            { key: 'II', value: 'II' },
            { key: 'III', value: 'III' },
            { key: 'IV', value: 'IV' },
            { key: 'V', value: 'V' },
        ],
        forceType: 'dropdown'
    },
    Gender: {
        forceType: 'radio',
    },
    DateofBirth: {
        validators: ['age']
    },
    PlaceofBirthCountry: {
        forceType: 'dropdown',
        length: 50
    },
    SocialSecurityNumber: {
        validators: ['ss']
    },
    DriversLicenseNumber: {
        validators: ['license'],
        length: 20
    },
    PersonalTelephoneNumber: {
        validators: ['phone']
    },
    BusinessTelephoneNumber: {
        validators: ['phone']
    },
    EmailAddress: {
        validators: ['email'],
    },
    NewBusinessFirmContactPhoneNumber: {
        validators: ['phone'],
    },
    AgentReportGenInfoPrem: {
        mask: [maskCurrencyNoSymbol]
    },
    AgentReportAgentInformationName: {
        validators: ['name'],
        length: 50
    },
    AgentReportAgentInformationLicenseNum: {
        length: 8
    },
    AgentReportAgentInformationBroker: {
        validators: ['validateFreeform'],
        length: 50
    },
    AgentReportAgentInformationShare: {
        validators: ['percentageNoZero'],
        length: 99
    },
    AgentReportAgentInformationCode: {
        length: 6
    },
    AgentReportAgentInformationSSN: {
        mask: ['mask-ss'],
        validators: ['ss']
    },
    AgentReportAgentInformationPhone: {
        validators: ['phone'],
        mask: [maskPhone]
    },
    AgentReportAgentInformationEmail: {
        validators: ['email'],
    },
    AgentReportAgentInformationWholesaler: {
        validators: ['name'],
        length: 40
    },
    PolicyOwnerSSN: {
        mask: ['mask-ss'],
        validators: ['ss']
    },
    PolicyOwnerTaxId: {
        mask: ['mask-tid'],
        validators: ['taxid']
    },
    PolicyOwnerPhone: {
        validators: ['phone'],
        mask: [maskPhone]
    },
    PolicyOwnerEmail: {
        validators: ['email'],
    },
    PolicyOwnerDateOfBirth: {
        validators: ['minAge']
    },
    PolicyOwnerTypeOther: {
        length: 50
    },
    PolicyOwnerRelationshipOther: {
        length: 50
    },
    PolicyOwnerEntityName: {
        length: 40
    },
    SigningOfficerDateOfBirth: {
        validators: ['minAge']
    },
    SigningOfficerEmail: {
        validators: ['email'],
    },
    SigningOfficerSoleSignerSSN: {
        mask: ['mask-ss'],
        validators: ['ss']
    },
    TrusteeEntityTaxID: {
        mask: ['mask-tid'],
        validators: ['taxid']
    },
    TINSSN: {
        mask: ['mask-ss'],
        validators: ['ss']
    },
    TINEmployerID: {
        mask: ['mask-tid'],
        validators: ['taxid']
    },
    BeneficiaryPhone: {
        validators: ['phone'],
        mask: [maskPhone]
    },
    BeneficiaryPercentage: {
        validators: ['percentage'],
    },
    BeneficiarySSN: {
        mask: ['mask-ss'],
        validators: ['ss']
    },
    BeneficiaryTaxID: {
        mask: ['mask-tid'],
        validators: ['taxid'],
        length: 9
    },
    BeneficiaryEmail: {
        validators: ['email'],
    },
    TermRidersAndBenefitsOther: {
        validators: ['noAllSpace']
    },
    ExistingPolicyNumber: {
        validators: ['noAllSpace'],
        length: 25
    },
    Insured: {
        validators: ['noAllSpace']
    },
    Owner: {
        validators: ['noAllSpace'],
        length: 40
    },
    InsuredOther: {
        validators: ['noAllSpace'],
        length: 40
    },
    TravelOutsideOfUSDuration: {
        validators: ['noAllSpace'],
        length: 20
    },
    OtherMedicalCatchAllTypeOther: {
        validators: ['noAllSpace'],
        length: 80
    },
    ConditionTreatmentOther: {
        validators: ['noAllSpace'],
        length: 50
    },
    FSBISectionAJobTitle: {
        validators: ['noAllSpace'],
        length: 20
    },
    FSBISectionABusName: {
        validators: ['noAllSpace'],
        length: 50
    },
    FSBISectionABusType: {
        validators: ['noAllSpace'],
        length: 30
    },
    FSBISectionAAmountDet: {
        validators: ['noAllSpace'],
        length: 40
    },
    FlexiblePremiumProductsBaseAmount: {
        mask: [maskCurrency],
        validators: ['termAmount']
    },
    FlexiblePremiumProductsSupplementalAmount: {
        mask: [maskCurrency],
        validators: ['SupplementAmount']
    },
    TermFaceAmount: {
        mask: [maskCurrency],
        validators: ['termAmount']
    },
    FlexiblePremiumIncreasingByPct: {
        validators: ['supplementPercentage']
    },
    FlexiblePremiumIncreasingOverYears: {
        validators: ['supplementYears']
    },
    RidersBenefitsPremiumRider: {
        validators: ['percentage']
    },
    IULFixedAcct: {
        validators: ['percentage']
    },
    IULBaseCappedIndex: {
        validators: ['percentage']
    },
    IULBaseHighPar: {
        validators: ['percentage']
    },
    IULSelectCappedIndex: {
        validators: ['percentage']
    },
    IULCappedIndex: {
        validators: ['percentage']
    },
    IULHighCappedIndex: {
        validators: ['percentage']
    },
    IULHighPar: {
        validators: ['percentage']
    },
    IULHangSeng: {
        validators: ['percentage']
    },
    IULEnhancedCapped: {
        validators: ['percentage']
    },
    IULEnhancedHighCapped: {
        validators: ['percentage']
    },
    PercentTotal: {
        validators: ['equals100']
    },
    IULMonthlyAutoTransferAmt: {
        validators: ['autoTransferAmt']
    },
    IULMonthlyAutoTransferNum: {
        validators: ['autoTransferNum'],
        length: 4
    },
    IULFAAllocBaseCappedIndex: {
        mask: [maskCurrencyNoSymbol]
    },
    IULFAAllocBaseHighPar: {
        mask: [maskCurrencyNoSymbol]
    },
    IULFAAllocSelectCappedIndex: {
        mask: [maskCurrencyNoSymbol]
    },
    IULFAAllocCappedIndex: {
        mask: [maskCurrencyNoSymbol]
    },
    IULFAAllocHighCappedIndex: {
        mask: [maskCurrencyNoSymbol]
    },
    IULFAAllocHighPar: {
        mask: [maskCurrencyNoSymbol]
    },
    IULFAAllocHangSeng: {
        mask: [maskCurrencyNoSymbol]
    },
    IULFAAllocEnhancedCapped: {
        mask: [maskCurrencyNoSymbol]
    },
    IULFAAllocEnhancedHighCapped: {
        mask: [maskCurrencyNoSymbol]
    },
    DollarTotal: {
        mask: [maskCurrencyNoSymbol]
    },
    IULProceedsAllocToSelectCappedIndex: {
        validators: ['percentage']
    },
    IULProceedsAllocToFixedAcct: {
        validators: ['percentage']
    },
    IULProceedsAllocToBaseCappedIndex: {
        validators: ['percentage']
    },
    IULProceedsAllocToBaseHighPar: {
        validators: ['percentage']
    },
    IULProceedsAllocToCappedIndex: {
        validators: ['percentage']
    },
    IULProceedsAllocToHighCappedIndex: {
        validators: ['percentage']
    },
    IULProceedsAllocToHighPar: {
        validators: ['percentage']
    },
    IULProceedsAllocToHangSeng: {
        validators: ['percentage']
    },
    IULProceedsAllocToEnhancedCapped: {
        validators: ['percentage']
    },
    IULProceedsAllocToEnhancedHighCapped: {
        validators: ['percentage']
    },
    ExistingPolicyTotalFaceAmount: {
        validators: ['termAmount']
    },
    OtherCompanyTotalFaceAmount: {
        validators: ['termAmount']
    },
    TotalNewCoverageToAccept: {
        validators: ['termAmount'],
        length: 16
    },
    FSBISectionAPercentOwn: {
        validators: ['percentage']
    },
    PaymentPlanAmount: {
        mask: [maskCurrency]
    },
    IllustrationOmitReason: {
        forceType: 'radio',
    },
    IllustrationInsuredAge: {
        validators: ['maxAge']
    },
    IllustrationYears: {
        validators: ['illustrationYears']
    },
    IllustrationPremiumYears: {
        validators: ['illustrationYears']
    },
    IllustrationRiders: {
        validators: ['name'],
        length: 40
    },
    IllustrationPolicyType: {
        length: 40
    },
    IllustrationDividendOption: {
        length: 40
    },
    TravelOutsideOfUSDate: {
        validators: ['moreThan1ShortDate']
    },
    PlannedTravelDate: {
        validators: ['dateShortFuture']
    },
    MarijuanaRecency: {
        validators: ['moreThan5MonthYear']
    },
    Occupation: {
        forceType: 'autocomplete',
    },
    AnLLifeOneType: {
        forceType: 'radio',
    },
    CIHasMedicalInsurance : {
        forceType: 'radio',
    },
    YesNo: {
        options: [
            { key: true, value: 'Yes' },
            { key: false, value: 'No' },
        ],
        forceType: false
    },
    Feet: {
        mask: ['mask-length-2'],
        validators: ['feet'],
        length: 2
    },
    Inches: {
        mask: ['mask-length-2'],
        validators: ['inches'],
        length: 2
    },
    WeightLossPounds: {
        validators: ['weightloss'],
        length: 3
    },
    // WeightLossPoundsStateVariation: {
    //     validators: ['weightloss']
    // },
    WeightGainPounds: {
        validators: ['weightloss'],
        length: 3
    },
    // WeightGainPoundsStateVariation: {
    //     validators: ['weightloss']
    // },
    Weight: {
        validators: ['weight'],
        length: 3
    },
    WeightLoss: {
        length: 3
    },
    FamilyHistoryConditionAgeOfOnset: {
        validators: ['maxAge'],
        length: 3
    },
    ExerciseTimeSpentMinutes: {
        length: 2
    },
    ExerciseTimeSpentHours: {
        length: 2
    },
    FamilyHistoryAgeIfLiving: {
        validators: ['maxAge'],
        length: 3
    },
    FamilyHistoryAgeAtDeath: {
        validators: ['maxAge'],
        length: 3
    },
    LTCDisabilityPercentage: {
        length: 3,
        validators: ['percentage']
    },
    BankAcctNum: {
        validators: ['noAllSpace'],
        length: 20
    },
    LTCOtherPolicyCertNum: {
        length: 20
    },
    CrimeCity: {
        validators: ['noAllSpace'],
        length: 23
    },
    EmployerName: {
        validators: ['noAllSpace'],
        length: 40
    },
    BankAcctOwnerRelationship: {
        length: 40
    },
    VisaTypeOther: {
        length: 30
    },
    FamilyHistoryCauseOfDeathOther: {
        length: 30
    },
    FamilyHistoryCancerOther: {
        length: 30
    },
    PlannedTravelCity: {
        validators: ['noAllSpace'],
        length: 23
    },
    TravelOutsideOfUSOwnBusinessDetails: {
        validators: ['noAllSpace'],
        length: 50
    },
    TravelOutsideOfUSOwnPropertyDetails: {
        validators: ['noAllSpace'],
        length: 30
    },
    TravelOutsideOfUSDestinationCity: {
        validators: ['noAllSpace'],
        length: 23
    },
    SupplementalQuestionContactDetails: {
        validators: ['noAllSpace']
    },
    CompletedDiagnosticTestTypeOther: {
        validators: ['noAllSpace'],
        length: 300
    },
    PendingTestTypeOther: {
        validators: ['noAllSpace'],
        length: 200
    },
    AviationMedCertDenialYes: {
        validators: ['noAllSpace'],
        length: 97
    },
    AviationAccidentsViolationsDetails: {
        validators: ['noAllSpace'],
        length: 100
    },
    AviationMilitaryCrewYes: {
        validators: ['noAllSpace'],
        length: 50
    },
    AviationMilitaryDutiesOther: {
        validators: ['noAllSpace'],
        length: 20
    },
    AviationMilitaryAircraftOther: {
        validators: ['noAllSpace'],
        length: 53
    },
    AviationMilitaryBranchOther: {
        length: 16
    },
    BankName: {
        validators: ['noAllSpace'],
        length: 50
    },
    BankAcctOwnerName: {
        validators: ['noAllSpace'],
        length: 50
    },
    BankAcctOwnerOtherDetails: {
        length: 20
    },
    LTCOtherPolicyBenefitsType: {
        length: 17
    },
    LTCCognitiveConditionsPhysician: {
        length: 50
    },
    LTCRequiresAssistancesPhysician: {
        length: 50
    },
    LTCAssistanceDevicesPhysician: {
        length: 50
    },
    LTCPhysicianHospitalDetails: {
        length: 50
    },
    PolicyOwnerTrustName: {
        length: 40
    },
    LTCCognitiveConditionsReason: {
        length: 200
    },
    LTCCognitiveConditionsDurationOfCondition: {
        length: 200
    },
    LTCRequiresAssistancesReason: {
        length: 200
    },
    LTCRequiresAssistancesDurationOfCondition: {
        length: 200
    },
    LTCAssistanceDevicesReason: {
        length: 200
    },
    LTCAssistanceDevicesDurationOfCondition: {
        length: 200
    },
    AlcoholAdvisedDetails: {
        validators: ['noAllSpace'],
        length: 150
    },
    CocaineDetails: {
        validators: ['noAllSpace'],
        length: 150
    },
    TranquilizersDetails: {
        validators: ['noAllSpace'],
        length: 150
    },
    DrugOrAlcoholUseDetails: {
        validators: ['noAllSpace'],
        length: 150
    },
    PrescriptionMedicalConditionOther: {
        validators: ['noAllSpace'],
        length: 40
    },
    DivePurposeDesc: {
        validators: ['noAllSpace'],
        length: 225
    },
    LienOrBankruptcyDetails: {
        validators: ['noAllSpace'],
        length: 75
    },
    OtherInterestedPartyDetails: {
        validators: ['noAllSpace'],
        length: 50
    },
    OfferedMoneyDetails: {
        validators: ['noAllSpace'],
        length: 50
    },
    OtherCompanyName: {
        validators: ['noAllSpace'],
        length: 20
    },
    ExistingPolicyCompanyOther: {
        validators: ['noAllSpace'],
        length: 30
    },
    PrimaryPhysicianLastVisitReason: {
        validators: ['noAllSpace'],
        length: 50
    },
    PremiumSourceDetails: {
        validators: ['noAllSpace'],
        length: 40
    },
    PremiumSourcesOther: {
        validators: ['noAllSpace'],
        length: 75
    },
    LenderRepaymentOtherFeesDetails: {
        validators: ['noAllSpace'],
        length: 75
    },
    TaxClassificationOther: {
        validators: ['noAllSpace'],
        length: 30
    },
    OccupationStatusOther: {
        validators: ['noAllSpace'],
        length: 25
    },
    PurposeofInsuranceOther: {
        validators: ['noAllSpace'],
        length: 30
    },
    OccupationOther: {
        validators: ['noAllSpace'],
        length: 30
    },
    ExerciseTypeOther: {
        validators: ['noAllSpace'],
        length: 46
    },
    RidersBenefitsOther: {
        validators: ['noAllSpace']
    },
    ExistingOwner: {
        validators: ['noAllSpace']
    },
    ExistingOwnerAR: {
        validators: ['noAllSpace']
    },
    ExistingInsurerAR: {
        validators: ['noAllSpace']
    },
    ExistingPolicyNumberAR: {
        validators: ['noAllSpace']
    },
    ExistingProductNameAR: {
        validators: ['noAllSpace']
    },
    ExistingGMAAR: {
        validators: ['noAllSpace']
    },
    ExistingWithdrawalOptionsAR: {
        validators: ['noAllSpace']
    },
    ExistingOtherAR: {
        validators: ['noAllSpace']
    },
    ProposedOwnerAR: {
        validators: ['noAllSpace']
    },
    ProposedInsurerAR: {
        validators: ['noAllSpace']
    },
    ProposedProductNameAR: {
        validators: ['noAllSpace']
    },
    ReplacementGMAAR: {
        validators: ['noAllSpace']
    },
    ReplacementOtherAR: {
        validators: ['noAllSpace']
    },
    NewBusinessFirmContactEmailAddress: {
        validators: ['noAllSpace', 'email']
    },
    ExistingPolicySoldTransferredYear: {
        mask: ['mask-integer-year'],
        validators: ['yearPastOrCurrent'],
        length: 4
    },
    BankAcctRoutingNum: {
        validators: ['USBankRouting'],
        length: 9
    },
    BankAcctRoutingNumOwner: {
        validators: ['USBankRouting'],
        length: 9
    },
    AsthmaLastOccurrence: {
        validators: ['dateShort']
    },
    AsthmaSteroidsDate: {
        validators: ['dateShort']
    },
    LTCHealthDate: {
        validators: ['moreThan5FullDate']
    },
    LTCRequiresAssistancesDate: {
        validators: ['moreThan5FullDate']
    },
    LTCCognitiveConditionsDate: {
        validators: ['moreThan5FullDate']
    },
    LTCAcceleratedBenefitPct: {
        validators: ['percentageNoZero']
    },
    AsthmaHospitalizedDate: {
        validators: ['moreThan5MonthYear']
    },
    AnxietyDisorderHospitalizedYes: {
        validators: ['moreThan5MonthYear']
    },
    UlcerativeSteroidsYes: {
        validators: ['moreThan3MonthYear']
    },
    BoneMissedYes: {
        validators: ['moreThan3MonthYear']
    },
    OsteoarthritisMissedDate: {
        validators: ['moreThan3MonthYear']
    },
    ArthritisMissedYes: {
        validators: ['moreThan3MonthYear']
    },
    OsteoporosisMissedYes: {
        validators: ['moreThan3MonthYear']
    },
    FibromyalgiaMissedYes: {
        validators: ['moreThan3MonthYear']
    },


    // bulk freeform validator to match Velogica
    BeneficiaryEntityName: {
        validators: ['validateForVelogica'],
        length: 50
    },
    BeneficiaryRelationshipOther: {
        validators: ['validateForVelogica'],
        length: 15
    },
    MarijuanaPrescriptionCardID: {
        validators: ['validateForVelogica'],
        length: 20
    },
    DeclinedRatedPostponedDetails: {
        validators: ['validateForVelogica', 'noAllSpace'],
        length: 70
    },
    LongTermAbsenceDetails: {
        validators: ['validateForVelogica', 'noAllSpace'],
        length: 200
    },
    DiveTypeDetails: {
        validators: ['validateForVelogica', 'noAllSpace'],
        length: 80
    },
    OtherDiveTypeDescription: {
        validators: ['validateForVelogica', 'noAllSpace'],
        length: 80
    },
    SoloDivesDetails: {
        validators: ['validateForVelogica', 'noAllSpace'],
        length: 80
    },
    CertificationLevel: {
        validators: ['validateForVelogica'],
        length: 18
    },
    CertificationOrganization: {
        validators: ['validateForVelogica'],
        length: 25
    },
    FamilyHistoryHealthStatus: {
        validators: ['validateForVelogica', 'noAllSpace'],
        length: 30
    },
    PrescriptionName: {
        forceType: 'autocomplete',
        validators: ['noAllSpace'],
        length: 20
    },
    DrugName: {
        validators: ['noAllSpace'],
        length: 15
    },
    DrugConvictionDetails: {
        validators: ['noAllSpace'],
        length: 70
    },
    AlcoholorDrugInterventionDetails: {
        validators: ['noAllSpace'],
        length: 70
    },
    AlcoholorDrugRecoverygroupDetails: {
        validators: ['noAllSpace'],
        length: 48
    },
    AsthmaMissedWorkDetails: {
        validators: ['validateForVelogica'],
        length: 50
    },
    AlcoholorDrugGuiltyDetails: {
        validators: ['validateForVelogica', 'noAllSpace'],
        length: 70
    },
    SleepApneaTreatmentOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    BenignTumorLocationOther: {
        validators: ['validateForVelogica'],
        length: 30
    },
    BenignTumorTreatmentOther: {
        validators: ['validateForVelogica'],
        length: 30
    },
    BenignTumorFollowupOther: {
        validators: ['validateForVelogica'],
        length: 30
    },
    BenignTumorFollowupYesOther: {
        length: 30
    },
    AnxietyDisorderDiagnosis: {
        validators: ['validateForVelogica'],
        length: 300
    },
    AnxietyDisorderNervousYes: {
        validators: ['validateForVelogica'],
        length: 300
    },
    AnxietyDisorderTreatmentOther: {
        validators: ['validateForVelogica'],
        length: 30
    },
    DepressionDiagnosis: {
        validators: ['validateForVelogica'],
        length: 300
    },
    DepressionTreatmentOther: {
        validators: ['validateForVelogica'],
        length: 30
    },
    UlcerativeTreatmentOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    UlcerativeSurgeryYesTypeOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    UlcerativeComplicationsYes: {
        validators: ['validateForVelogica'],
        length: 99
    },
    BoneSurgeryYesType: {
        validators: ['validateForVelogica'],
        length: 300
    },
    BoneAssistiveYesTypeOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    OsteoarthritisSteroidsYesDetail: {
        validators: ['validateForVelogica'],
        length: 300
    },
    OsteoarthritisJointsOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    OsteoarthritisSurgeryYesBody: {
        validators: ['validateForVelogica']
    },
    OsteoarthritisSymptomsType: {
        validators: ['validateForVelogica'],
        length: 300
    },
    OsteoarthritisAssistiveYesOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    OsteoarthritisTherapyYesDetail1: {
        validators: ['validateForVelogica'],
        length: 300
    },
    OsteoarthritisTherapyYesDetail3: {
        validators: ['validateForVelogica'],
        length: 300
    },
    ArthritisSteroidsYesDetail: {
        validators: ['validateForVelogica'],
        length: 300
    },
    ArthritisJointsOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    ArthritisSurgeryYesBody: {
        validators: ['validateForVelogica']
    },
    ArthritisSymptomsYesType: {
        validators: ['validateForVelogica'],
        length: 99
    },
    ArthritisAssistiveYesTypeOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    ArthritisTherapyYesType: {
        validators: ['validateForVelogica'],
        length: 300
    },
    ArthritisTherapyYesDuration: {
        validators: ['validateForVelogica'],
        length: 300
    },
    OsteoporosisTreatmentOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    OsteoporosisDensityYesStudy: {
        validators: ['validateForVelogica']
    },
    OsteoporosisFracturesYesType: {
        validators: ['validateForVelogica'],
        length: 300
    },
    OsteoporosisTherapyYesType: {
        validators: ['validateForVelogica']
    },
    OsteoporosisTherapyYesDuration: {
        validators: ['validateForVelogica']
    },
    OsteoporosisBonesOther: {
        length: 300
    },
    FibromyalgiaMedications: {
        validators: ['validateForVelogica'],
        length: 300
    },
    FibromyalgiaDepressionYesOther: {
        validators: ['validateForVelogica'],
        length: 300
    },
    AIDSHIVDetails: {
        validators: ['validateForVelogica', 'noAllSpace'],
        length: 200
    },
    LTCAgentOtherPoliciesCompanyFL: {
        validators: ['validateForVelogica'],
        length: 30
    },
    LTCAgentOtherPoliciesCertificateFL: {
        validators: ['validateForVelogica'],
        length: 20
    },
    LTCAgentOtherPoliciesTypeFL: {
        validators: ['validateForVelogica'],
        length: 17
    },
    OwnerSSN: {
        mask: ['mask-ss'],
        validators: ['ss']
    },
    TotalCholesterolReading: {
        validators: ['threeDigit'],
        length: 3
    },
    HDLReading: {
        validators: ['threeDigit'],
        length: 3
    },
    TerminationDateFL: {
        validators: ['dateFuture']
    },
    ProposedPolicyFundsDateFL: {
        validators: ['dateFuture']
    },
    ProposedPolFundsDateFL: {
        validators: ['dateFuture', 'lessThan1Yr']
    },
    TerminationDateRI: {
        validators: ['dateFuture']
    },
    PremiumDateRI: {
        validators: ['dateFuture']
    },
    TerminationDateRIv2: {
        validators: ['datePast']
    },
    PremiumDateRIv2: {
        validators: ['datePast']
    },
    ProposedEffectiveDateRI: {
        validators: ['dateFuture']
    },
    ProposedEffectiveDateFL: {
        validators: ['dateFuture']
    },



    // add/remove label for form multiplereponse questions
    AgentReportAgentInformation: {
        multiResponseLabel: 'Agent',
    },
    AgentReportAgentInformationFL: {
        multiResponseLabel: 'Agent',
    },
    PolicyOwnerInformation: {
        multiResponseLabel: 'Policy Owner'
    },
    TrustGrantorCompound: {
        multiResponseLabel: 'Grantor'       
    },
    SigningOfficerCompound: {
        multiResponseLabel: 'Signer',
    },
    PartnershipStatementCompound: {
        multiResponseLabel: 'Partnership',
    },
    PartnershipPartnerDetails: {
        multiResponseLabel: 'Partner',
    },
    BeneficiaryInformation: {
        multiResponseLabel: 'Beneficiary',
    },
    CIReplaceOrModify: {
        multiResponseLabel: 'Policy',
    },
    CIReplaceOrModifyDC: {
        multiResponseLabel: 'Policy',
    },
    IULProceedsAlloc: {
        multiResponseLabel: 'Source Account',
    },
    VULFundOtherOptionsCompound: {
        multiResponseLabel: 'Portfolio',
    },
    VULSegmentFromBCIACompound: {
        multiResponseLabel: 'Account',
    },
    VULSegmentFromBHPCIACompound: {
        multiResponseLabel: 'Account',
    },
    //JIRA: 3476 Begin
    VULSegmentFromBCTYIACompound: {        
        multiResponseLabel: 'Account',
    },
    VULSegmentFromHCIACompound: {
        multiResponseLabel: 'Account',
    },
    //JIRA: 3476 End
    VULAllocationofMonthlyChargesCompound: {
        multiResponseLabel: 'Account',
    },
    AccountBalancerCompound: {
        multiResponseLabel: 'Account',
    },
    CostBenefitPACoveragePolicy: {
        multiResponseLabel: 'Policy',
    },
    IllustrationInsuredInfo: {
        multiResponseLabel: 'Insured',
    },
    ExistingPolicyDetails: {
        multiResponseLabel: 'Existing Policy',
    },
    // ReplaceExistingInsuranceOrUseFunds : {
    //     validators: ['existingInsuranceAnnuities']
    // },
    OtherCompanyApplicationDetail: {
        multiResponseLabel: 'Pending Application',
    },
    ReplacedPoliciesCompoundAK: {
        multiResponseLabel: policyContract,
    },
    ReplacedPoliciesCompoundMT: {
        multiResponseLabel: policyContract,
    },
    ReplacedPoliciesCompoundMO: {
        multiResponseLabel: policyContract,
    },
    ReplacedPoliciesCompoundUS: {
        multiResponseLabel: policyContract,
    },
    ReplacedPoliciesCompoundVA: {
        multiResponseLabel: policyContract,
    },
    ReplacedPoliciesCompoundCA: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundDC: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundDE: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundGA: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundID: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundIL: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundIN: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundKS: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundMA: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundNV: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundOK: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundPA: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundTN: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundUS5017: {
        multiResponseLabel: 'Policy',
    },
    ParentNB5259KS: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundPR: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundMD: {
        multiResponseLabel: 'Policy',
    },
    ParentNB5135AR: {
        multiResponseLabel: policyContract,
    },
    ParentNB5201WY: {
        multiResponseLabel: policyContract,
    },
    ReplacedPoliciesCompoundWY: {
        multiResponseLabel: 'Policy',
    },
    NewSurrenderPeriodCompoundWY: {
        multiResponseLabel: 'Period',
    },
    PurchasedSurrenderPeriodCompoundWY: {
        multiResponseLabel: 'Period',
    },
    ReplacedPoliciesCompoundMN: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompoundFL: {
        multiResponseLabel: 'Policy',
    },
    ReplacementNoticeCompoundRI: {
        multiResponseLabel: 'Replacement',
    },
    ParentNB5046WA: {
        multiResponseLabel: 'Replacement',
    },
    PoliciesReplacedCompoundWA: {
        multiResponseLabel: policyContract,
    },
    IncomeEarnedDetails: {
        multiResponseLabel: 'Income Source',
    },
    IncomeUnearnedDetails: {
        multiResponseLabel: 'Income Source',
    },
    AnLbreakdownAssets: {
        multiResponseLabel: 'Asset',
    },
    AnLbreakdownLiabilities: {
        multiResponseLabel: 'Liability',
    },
    AnLbreakdownREAssets: {
        multiResponseLabel: 'Property',
    },
    BusFnclSectionBBusFinancialConf: {
        multiResponseLabel: 'Business',
    },
    BusFnclBOwner: {
        multiResponseLabel: 'Partner',
    },
    SpecialistDetails: {
        multiResponseLabel: 'Specialist',
    },
    TobaccoDetails: {
        multiResponseLabel: 'Nicotine/Tobacco',
    },
    ExerciseDetails: {
        multiResponseLabel: 'Exercise',
    },
    PlannedTravelDetails: {
        multiResponseLabel: 'Destination',
    },
    CrimeDetails: {
        multiResponseLabel: 'Crime',
    },
    DiveDetails: {
        multiResponseLabel: 'Dive',
    },
    AutoRacingVehicles: {
        multiResponseLabel: 'Vehicle',
    },
    MotorcycleRacingVehicles: {
        multiResponseLabel: 'Vehicle',
    },
    BoatRacingVehicles: {
        multiResponseLabel: 'Vehicle',
    },
    ClimbingRecentAloneDetails: {
        multiResponseLabel: 'Climb',
    },
    ClimbingRecentwoRopeDetails: {
        multiResponseLabel: 'Climb',
    },
    ClimbingPlanned: {
        multiResponseLabel: 'Climb',
    },
    ClimbingPast: {
        multiResponseLabel: 'Location',
    },
    BungeeBaseJumping: {
        multiResponseLabel: 'Type',
    },
    SkiOrSnow: {
        multiResponseLabel: 'Type',
    },
    HeliSkiing: {
        multiResponseLabel: 'Type',
    },
    AviationAnnualHours: {
        multiResponseLabel: 'Purpose',
    },
    TravelOutsideOfUSDetails: {
        multiResponseLabel: 'Trip',
    },
    TravelOutsideOfUSPlansDetails: {
        multiResponseLabel: 'Planned Trip',
    },
    FamilyHistoryDetails: {
        multiResponseLabel: 'Family Member',
    },
    FamilyHistoryMedicalConditions: {
        multiResponseLabel: medicalCondition,
    },
    MedicationsDetails: {
        multiResponseLabel: 'Medication',
    },
    MedicalConditionDetails: {
        multiResponseLabel: medicalCondition,
    },
    OsteoarthritisSurgeryYes: {
        multiResponseLabel: 'Surgery',
    },
    OsteoarthritisTherapyYes: {
        multiResponseLabel: 'Therapy',
    },
    ArthritisSurgeryYes: {
        multiResponseLabel: 'Surgery',
    },
    ArthritisTherapyYes: {
        multiResponseLabel: 'Therapy',
    },
    OsteoporosisFracturesYes: {
        multiResponseLabel: 'Fracture',
    },
    OsteoporosisTherapyYes: {
        multiResponseLabel: 'Therapy',
    },
    CompletedDiagnosticTestDetails: {
        multiResponseLabel: 'Diagnostic Test',
    },
    PendingTestDetails: {
        multiResponseLabel: 'Test/Procedure',
    },
    OtherMedicalCatchAllDetails: {
        multiResponseLabel: medicalCondition,
        length: 255
    },
    AlcoholConsumptionDetails: {
        multiResponseLabel: 'Alcohol',
    },
    AlcoholorDrugPresentConsumption: {
        multiResponseLabel: 'Alcohol',
    },
    DrugConsumptionDetails: {
        multiResponseLabel: 'Substance',
    },
    LTCLapseTerminationRecipients: {
        multiResponseLabel: 'Person',
    },
    LTCOtherPolicyDetails: {
        multiResponseLabel: 'Policy',
    },
    LTCMedicalConditionsCompound: {
        multiResponseLabel: 'Condition',
    },
    LTCRequiresAssistanceCompound: {
        multiResponseLabel: 'Activity',
    },
    LTCUsesAssistanceDevicesCompound: {
        multiResponseLabel: 'Device',
    },
    LTCFacilitatedLivingCompound: {
        multiResponseLabel: 'Facility',
    },
    LTCLapseTerminationRecipientsFL: {
        multiResponseLabel: 'Person',
    },
    LTCOtherPolicyDetailsFL: {
        multiResponseLabel: 'Policy',
    },
    LTCMedicalConditionsCompoundFL: {
        multiResponseLabel: 'Condition',
    },
    LTCRequiresAssistanceCompoundFL: {
        multiResponseLabel: 'Activity',
    },
    LTCUsesAssistanceDevicesCompoundFL: {
        multiResponseLabel: 'Device',
    },
    LTCFacilitatedLivingCompoundFL: {
        multiResponseLabel: 'Facility',
    },
    LTCLapseTerminationRecipientsNJ: {
        multiResponseLabel: 'Person',
    },
    LTCOtherPolicyDetailsNJ: {
        multiResponseLabel: 'Policy',
    },
    LTCMedicalConditionsCompoundNJ: {
        multiResponseLabel: 'Condition',
    },
    LTCRequiresAssistanceCompoundNJ: {
        multiResponseLabel: 'Activity',
    },
    LTCUsesAssistanceDevicesCompoundNJ: {
        multiResponseLabel: 'Device',
    },
    LTCFacilitatedLivingCompoundNJ: {
        multiResponseLabel: 'Facility',
    },
    LTCLapseTerminationRecipientsCA: {
        multiResponseLabel: 'Person',
    },
    LTCOtherPolicyDetailsCA: {
        multiResponseLabel: 'Policy',
    },
    LTCDevicesYesCA: {
        multiResponseLabel: 'Device',
    },
    LTCRequiredAssistanceYesCA: {
        multiResponseLabel: 'Activity',
    },
    LTCMedicalConditionCYesCA: {
        multiResponseLabel: 'Condition',
    },
    LTCMedicalConditionDYesCA: {
        multiResponseLabel: 'Condition',
    },
    LTCHospitalizationYesCA: {
        multiResponseLabel: 'Treatment',
    },
    LTCNursingHomeYesCA: {
        multiResponseLabel: 'Facility',
    },
    LTCHomeHealthCareYesCA: {
        multiResponseLabel: 'Service',
    },
    OutstandingMedicalRequirements: {
        multiResponseLabel: 'Requirement',
    },
    AgentReportExistingOtherHeatlhPolInForce: {
        multiResponseLabel: 'Policy',
    },
    AgentReportExistingOtherHeatlhPollast5: {
        multiResponseLabel: 'Policy',
    },
    LTCAgentOtherPoliciesNJ: {
        multiResponseLabel: 'Policy',
    },
    LTCAgentReportExistingOtherHeatlhPolInForceNJ: {
        multiResponseLabel: 'Policy',
        length: 20
    },
    LTCAgentReportExistingOtherHeatlhPolInForceListNJ: {
        multiResponseLabel: 'Policy',
        length: 20
    },
    LTCAgentReportExistingOtherHeatlhPollast5NJ: {
        multiResponseLabel: 'Policy',
        length: 30
    },
    LTCAgentReportExistingOtherHeatlhPollast5ListNJ: {
        multiResponseLabel: 'Policy',
        length: 30
    },
    AgentReportExistingOtherHeatlhPolInForceFL: {
        multiResponseLabel: 'Policy',
    },
    AgentReportExistingOtherHeatlhPollast5FL: {
        multiResponseLabel: 'Policy',
    },
    AgentReportExisting1035DetailsFL: {
        multiResponseLabel: 'Policy',
    },
    LTCAgentOtherPoliciesFL: {
        multiResponseLabel: 'Policy',
    },
    ReplacedPoliciesCompound: {
        multiResponseLabel: 'Policy',
    },
    CostBenefitPACoverageRiders: {
        multiResponseLabel: 'Rider',
    },
    CurrentPolicyInformationCompoundFL: {
        multiResponseLabel: 'Policy',
    },
    AlcoholConsumptionPast10Details: {
        multiResponseLabel: 'Type of Alcohol',
    },
    ReplacedPoliciesKSCompound: {
        multiResponseLabel: 'Policy',
    },
    ClimbingClimbs: {
        multiResponseLabel: 'Climb',
    },

    SiblingCoverageDetails: {
        length: 75
    },
    MotherNotInsuredReason: {
        length: 25
    },
    FatherNotInsuredReason: {
        length: 25
    },
    GuardianNotInsuredReason: {
        length: 25
    },
    ExemptPayeeCode: {
        length: 99
    },
    ExemptionfromFATCA: {
        length: 2
    },
    AdditionalPolicyName: {
        length: 50
    },
    CIReplaceCompany: {
        length: 20
    },
    CIReplacePolicyNo: {
        length: 17
    },
    CIReplaceType: {
        length: 12
    },
    LTCDisabilityBenefitType: {
        length: 20
    },
    LTCDisabilityReason: {
        length: 50
    },
    LTCDeclinedRatedReason: {
        length: 70
    },
    LTCOtherPolicyCompany: {
        length: 30
    },
    VULSegmentFromBCIAAccountOther: {
        length: 20
    },
    VULSegmentFromBHPCIAAccountOther: {
        length: 20
    },
    //JIRA: 3476 Begin
    VULSegmentFromBCTYIAAccountOther: {
        length: 20
    },
    VULSegmentFromHCIAAccountOther: {
        length: 20
    },
    //JIRA: 3476 End
    LenderNames: {
        length: 30
    },
    CollateralType: {
        length: 15
    },
    ProposedPremiumModeFL: {
        length: 16
    },
    ModeOfPayRI: {
        length: 33
    },
    FSBISectionABusWebAddress: {
        length: 45
    },
    BusinessFinancialABusPurposeOther: {
        length: 25
    },
    FSBISectionAPartnersDet: {
        length: 40
    },
    FSBISectionBFMVDet: {
        length: 75
    },
    BusFnclBOwnerName: {
        length: 50
    },
    BusFnclBOwnerTitle: {
        length: 20
    },
    BusFnclBOwnerOtherInsPurp: {
        length: 30
    },
    SigningOfficerTitle: {
        length: 20
    },
    AnLbreakdownAssetsOther: {
        length: 20
    },
    AnLbreakdownLiabilitiesOther: {
        length: 20
    },
    AnLbreakdownREDesc: {
        length: 20
    },
    AnLbreakdownREValueDet: {
        length: 20
    },
    FundByTrustDetail: {
        length: 75
    },
    MedicalGroupProviderName: {
        length: 50
    },
    HealthInsuranceProviderName: {
        length: 50
    },
    ConditionDiagnosisOtherDetails: {
        length: 70
    },
    BoneDiagnosisOther: {
        length: 300
    },
    AutoRacingTrack: {
        length: 78
    },
    AutoRacingVehicleType: {
        length: 38
    },
    AutoRacingVehicleClass: {
        length: 40
    },
    AutoRacingVehicleEngine: {
        length: 38
    },
    AutoRacingDisciplineDetails: {
        length: 37
    },
    SkydivingCompetitionDetails: {
        length: 85
    },
    SkydivingClubName: {
        length: 70
    },
    ClimbingRecentAloneLocation: {
        length: 30
    },
    ClimbingRecentAloneDifficulty: {
        length: 10
    },
    ClimbingRecentwoRopeLocation: {
        length: 30
    },
    ClimbingRecentwoRopeDifficulty: {
        length: 10
    },
    ClimbingEquipment: {
        length: 100
    },
    ClimbingPlannedLocation: {
        length: 40
    },
    ClimbingPlannedDifficulty: {
        length: 10
    },
    ClimbingPastLocation: {
        length: 40
    },
    BungeeBaseJumpingActivity: {
        length: 25
    },
    BungeeBaseJumpingLocation: {
        length: 28
    },
    BungeeBaseJumpingClubName: {
        length: 60
    },
    DrugFormOther: {
        length: 12
    },
    EnterNewBusinessFirmContact: {
        length: 40,
        validators: ['noAllSpace']
    },
    POSName: {
        length: 50
    },
    CommentSpecialHandlingInstructions: {
        length: 300
    },
    ParaMedCompanyOther: {
        length: 40
    },
    AgentReportGenInfoTPRightsDetails: {
        length: 75
    },
    AgentReportGenInfoMedEvalDetails: {
        length: 75
    },
    AgentReportGenInfoNotMet: {
        length: 75
    },
    AgentReportExistingOtherHeatlhPolInForceList: {
        length: 18
    },
    AgentReportExistingOtherHeatlhPollast5List: {
        length: 30
    },
    IncomeUnearnedOther: {
        length: 15
    },
    IncomeEarnedOther: {
        length: 23
    },
    CurrentPremiumModeFL: {
        length: 16
    }
};